export default function PointsBar({ used, total, label, color = 'bg-teal' }) {
  const pct = Math.min((used / total) * 100, 100);
  const remaining = total - used;
  return (
    <div className="w-full">
      {label && <div className="text-xs text-brand-ink/70 mb-1">{label}</div>}
      <div className="h-2 bg-brand-ink/10 rounded-full overflow-hidden">
        <div className={`h-full ${color} rounded-full transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
      <div className="flex justify-between text-xs mt-1">
        <span className="text-brand-ink/65">{used.toLocaleString()} used</span>
        <span className="text-brand-ink/75 font-medium">{remaining.toLocaleString()} left</span>
      </div>
    </div>
  );
}
